import { ceruleanContrastColor } from '../contrastColors';

export const ceruleanDefault: string[] = [
  '#190055',
  '#1E4C81',
  '#256E96',
  '#3091AA',
  '#58B4B9',
  ceruleanContrastColor,
];

export const ceruleanDefaultMixed: string[] = [
  ceruleanDefault[0],
  ceruleanDefault[2],
  ceruleanDefault[4],
  ceruleanDefault[1],
  ceruleanDefault[3],
  ceruleanDefault[5],
];
